import { render } from "./humanityCourseCreate.vue?vue&type=template&id=105d1709&scoped=true"
import script from "./humanityCourseCreate.vue?vue&type=script&lang=js"
export * from "./humanityCourseCreate.vue?vue&type=script&lang=js"

import "./humanityCourseCreate.vue?vue&type=style&index=0&id=105d1709&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105d1709"]])

export default __exports__